/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCustomListMonitoringField,
    InternalApiCustomListMonitoringFieldFromJSON,
    InternalApiCustomListMonitoringFieldToJSON,
    InternalApiCustomListScreeningField,
    InternalApiCustomListScreeningFieldFromJSON,
    InternalApiCustomListScreeningFieldToJSON,
    InternalApiCustomListScreeningFieldWithList,
    InternalApiCustomListScreeningFieldWithListFromJSON,
    InternalApiCustomListScreeningFieldWithListToJSON,
} from '../models';

export interface AddMonitoringFieldRequest {
    customListId: string;
    internalApiCustomListMonitoringField: InternalApiCustomListMonitoringField;
}

export interface AddScreeningFieldRequest {
    customListId: string;
    internalApiCustomListScreeningField: InternalApiCustomListScreeningField;
}

export interface DeleteMonitoringFieldRequest {
    customListId: string;
    fieldId: string;
}

export interface DeleteScreeningFieldRequest {
    customListId: string;
    fieldId: string;
}

export interface GetMonitoringFieldsRequest {
    customListId: string;
}

export interface GetScreeningFieldsRequest {
    customListId: string;
}

/**
 * 
 */
export class CustomListUsableFieldApi extends runtime.BaseAPI {

    /**
     * Creates new monitoring field for custom list
     */
    async addMonitoringFieldRaw(requestParameters: AddMonitoringFieldRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListMonitoringField>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling addMonitoringField.');
        }

        if (requestParameters.internalApiCustomListMonitoringField === null || requestParameters.internalApiCustomListMonitoringField === undefined) {
            throw new runtime.RequiredError('internalApiCustomListMonitoringField','Required parameter requestParameters.internalApiCustomListMonitoringField was null or undefined when calling addMonitoringField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/monitoring-fields`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListMonitoringFieldToJSON(requestParameters.internalApiCustomListMonitoringField),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListMonitoringFieldFromJSON(jsonValue));
    }

    /**
     * Creates new monitoring field for custom list
     */
    async addMonitoringField(requestParameters: AddMonitoringFieldRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListMonitoringField> {
        const response = await this.addMonitoringFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates new screening field for custom list
     */
    async addScreeningFieldRaw(requestParameters: AddScreeningFieldRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListScreeningField>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling addScreeningField.');
        }

        if (requestParameters.internalApiCustomListScreeningField === null || requestParameters.internalApiCustomListScreeningField === undefined) {
            throw new runtime.RequiredError('internalApiCustomListScreeningField','Required parameter requestParameters.internalApiCustomListScreeningField was null or undefined when calling addScreeningField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/screening-fields`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListScreeningFieldToJSON(requestParameters.internalApiCustomListScreeningField),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListScreeningFieldFromJSON(jsonValue));
    }

    /**
     * Creates new screening field for custom list
     */
    async addScreeningField(requestParameters: AddScreeningFieldRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListScreeningField> {
        const response = await this.addScreeningFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes usable monitoring field from custom list
     */
    async deleteMonitoringFieldRaw(requestParameters: DeleteMonitoringFieldRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling deleteMonitoringField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling deleteMonitoringField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/monitoring-fields/{fieldId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes usable monitoring field from custom list
     */
    async deleteMonitoringField(requestParameters: DeleteMonitoringFieldRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteMonitoringFieldRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes usable screening field from custom list
     */
    async deleteScreeningFieldRaw(requestParameters: DeleteScreeningFieldRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling deleteScreeningField.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling deleteScreeningField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/screening-fields/{fieldId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes usable screening field from custom list
     */
    async deleteScreeningField(requestParameters: DeleteScreeningFieldRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteScreeningFieldRaw(requestParameters, initOverrides);
    }

    /**
     * Gets all screening fields for all custom lists in organisation
     */
    async getAllScreeningFieldsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCustomListScreeningFieldWithList>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/screening-fields`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCustomListScreeningFieldWithListFromJSON));
    }

    /**
     * Gets all screening fields for all custom lists in organisation
     */
    async getAllScreeningFields(initOverrides?: RequestInit): Promise<Array<InternalApiCustomListScreeningFieldWithList>> {
        const response = await this.getAllScreeningFieldsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all monitoring fields for custom list
     */
    async getMonitoringFieldsRaw(requestParameters: GetMonitoringFieldsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCustomListMonitoringField>>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getMonitoringFields.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/monitoring-fields`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCustomListMonitoringFieldFromJSON));
    }

    /**
     * Gets all monitoring fields for custom list
     */
    async getMonitoringFields(requestParameters: GetMonitoringFieldsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiCustomListMonitoringField>> {
        const response = await this.getMonitoringFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all screening fields for custom list
     */
    async getScreeningFieldsRaw(requestParameters: GetScreeningFieldsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiCustomListScreeningField>>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getScreeningFields.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/screening-fields`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiCustomListScreeningFieldFromJSON));
    }

    /**
     * Gets all screening fields for custom list
     */
    async getScreeningFields(requestParameters: GetScreeningFieldsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiCustomListScreeningField>> {
        const response = await this.getScreeningFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
